import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import * as fromModel from '../../services/models/';
import { Constant } from '../../../environments/constants';


export const INIT_UI_STATE: fromModel.IUIState = {
  action: fromModel.UI_STATE_ACTION.NONE,
  actionDispatchedBy: 'Initial',
  actionHistory: [],
  ShowProgressBar: false,
  ShowMsg: false,  
  Msg: '',
  MsgType: fromModel.MSGTYPE.NULL,
  Refresh: false,
  //IsPlanDirty: false
};

@Injectable({
  providedIn: 'root'
})
export class UIStateService {

  protected uiStateSubject: BehaviorSubject<fromModel.IUIState>;
  public uiState: fromModel.IUIState;

  constructor() { 
    this.uiState = JSON.parse(JSON.stringify(INIT_UI_STATE));
    this.uiStateSubject = new BehaviorSubject<fromModel.IUIState>(this.uiState);
  }

  public subscribe(callback: (context: fromModel.IUIState) => void): Subscription{    
    return this.uiStateSubject.subscribe(callback);    
  }

  public dispatchAction(act: string, dispatchedBy: string, payload: any | null): void {
    this.uiState.action = <fromModel.UI_STATE_ACTION>act;
    this.uiState.actionDispatchedBy = dispatchedBy;
    let _contextUpdateReq = true;

    switch (<fromModel.UI_STATE_ACTION>act){
      case fromModel.UI_STATE_ACTION.NONE:
        //console.log('no action');
        break;
      case fromModel.UI_STATE_ACTION.RESET:
        console.log('%c Reset UI State', Constant.consoleLogStyle.uiState);
        this.uiState = JSON.parse(JSON.stringify(INIT_UI_STATE));      
        break;
      case fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR: 
        if(this.uiState.ShowProgressBar !== payload){          
          this.uiState.ShowProgressBar = payload; 
        } else {
          _contextUpdateReq = false;
        }        
        break;
      
      case fromModel.UI_STATE_ACTION.SHOWERRORMSG:
        this.uiState.ShowMsg = payload.ShowMsg;
        this.uiState.Msg = payload.Msg;
        this.uiState.MsgType = payload.MsgType;
        if(payload){
          this.uiState.ShowProgressBar = false;
        }
        break;
      case fromModel.UI_STATE_ACTION.REFRESH:
        this.uiState.Refresh = payload;        
        break;
      // case fromModel.UI_STATE_ACTION.PLANDIRTY:
      //   this.uiState.IsPlanDirty = payload;        
      //   break;
    }
    
    if(_contextUpdateReq){
      this.uiState.actionHistory.push(`${act}: ${dispatchedBy} - ${payload}`);
      const dispatchedContext: fromModel.IUIState = JSON.parse(JSON.stringify(this.uiState));    
      this.uiStateSubject.next(dispatchedContext);
    }    
  }
}

